module.exports = __webpack_public_path__ + "media/images/img_bulb-5f748b83b9ee4a262a68f54696b038b7.png";